





























import { Component, Vue, Prop } from 'vue-property-decorator';
import { signIn, signOut, signedIn, authManager} from '../utils/login';
import { User } from 'oidc-client';
import * as Constants from '@/utils/constants';

@Component
export default class NavMenu extends Vue {

    logout() {
        signOut();
    }

    @Prop()
    user: any;

    created() {
        
    }

    get isSignedIn() {
      return this.user !== null;
    }

    get isAdmin() {
      return this.user 
             ? this.user.profile.roles.indexOf(Constants.ADMIN_ROLE) > -1
             : false;
    }
}
